export default __webpack_public_path__ + "static/media/Alchemy Chains 2.e94f6c2e.png";